/**
 * Checks if the `current` version [a, b, ... n] is higher than the `compare` [a, b, ... m] version.
 *
 * If two versions of different length are used as params, like "1.2.3.4" and "1.2", the latter is treated as "1.2.0.0"
 * @params current: number[] - an array representing a version, like [0.1.2]
 * @params compare: number[] - an array representing a version, like [1.2.4]
 * @returns boolean
 */
export function isHigherVersion(current: number[], compare: number[]): boolean {
  const longest =
    current.length > compare.length ? current.length : compare.length;
  for (let i = 0; i < longest; i++) {
    const cur = current[i] ?? 0;
    const com = compare[i] ?? 0;
    if (cur === com) continue;
    else if (cur > com) return true;
    else if (com > cur) return false;
  }
  return false;
}

export function parseVersion(version: string): number[] | null {
  // null (not []) for malformed input: isHigherVersion pads missing
  // components with 0, so a [] sentinel would silently compare as v0.0.0 —
  // returning null makes forgetting the check a compile error instead.
  // Number("") is 0, so blank strings and empty dot-components ("26..8", ".")
  // must be rejected here too.
  const tokens = version.split(".");
  if (tokens.some((token) => !token.trim())) {
    return null;
  }
  const parsed = tokens.map(Number);
  return parsed.every(Number.isFinite) ? parsed : null;
}
